const export_options = [
  { label: "Eksport produktów", value: "products" },
  { label: "Eksport aliasów", value: "product_aliases" },
];

export default export_options;
